export default __webpack_public_path__ + "static/media/nationwide.9abba3d0.svg";